<p class="text-center font-small mt-0 terms">
  By continuing, you agree to the<br />
  <a yat-link [yatExternalLink]="ACADEMIC_PROGRAM_TERMS_URL" class="link link-secondary link-underline">Academic&nbsp;Program&nbsp;Terms</a>. You confirm you
  will use the Academic Program for permitted (not-for-profit) purposes only.
</p>
